import React, { useState } from 'react'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../hoc/formikComponents/FormikControl.js'
import { useMutation, useQuery } from 'react-query'
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import * as BiIcons from 'react-icons/bi';
import * as AiIcons from 'react-icons/ai';
import { useQueryClient } from 'react-query'
import { useHistory } from "react-router-dom";
import { useParams } from 'react-router'
import swal from '@sweetalert/with-react';



function ListofImsClauses() {
    const { _id } = useParams()
    const history = useHistory();
    const queryClient = useQueryClient();
    const handleRoute = () => {
        window.location.href = "/admin/imsclausesmaster"
    }
    const edit = (id) => {
        window.location.href = "/admin/updateimsclausesmaster/" + id;
    }
    function onSelection() {
    
    }
    const { data: ClausesData, isLoading } = useQuery(
        'ClausesList',
        //  () => Fetcher('get', '/api/clauses/get/listclauses', {}))
        () => Fetcher('get', '/api/imsclausesmaster/get/listimsclauses', {}))

    if (isLoading) return <div>Loading</div>
    return (
        <div>
            <Formik
                enableReinitialize={true}
               // initialValues={initialValues}
            // validationSchema={validationSchema}
              //  onSubmit={onSubmit}
            >
                {formik => <Form>
                    <div className="row">
                        <div className="col-sm-11" />
                        <div className="col-sm-1">
                            <button type="button" className="btn btn-success" onClick={() => handleRoute()}>Add</button>
                        </div>
                        <div className="col-lg-19 col-lg-offset-1">
                            <div class="card-body table-responsive">
                                <table className="table table-bordered">
                                    <thead className="table-primary">
                                        <tr>
                                            <th scope="col" className="text-center" style={{ "width": "100px" }}>#</th>
                                            <th scope="col" className="text-center" style={{ "width": "180px" }}> Process Name </th>

                                            <th scope="col" className="text-center" colspan="4">Clause Details</th>
                                            <th scope="col" className="text-center" colspan="4">Action</th>

                                        </tr>
                                        <tr>
                                            <th scope="col" className="text-center" style={{ "width": "100px" }}></th>
                                            <th scope="col" className="text-center" style={{ "width": "180px" }}></th>

                                            <th scope="col" className="text-center" style={{ "width": "120px" }} colspan="2">Clause No</th>

                                            <th scope="col" className="text-center" style={{ "width": "120px" }} colspan="2">Clause Description</th>

                                            <th scope="col" className="text-center" style={{ "width": "180px" }}></th>
                                        </tr>
                                    </thead>
                                    <tbody >

                                        {
                                            ClausesData.data.response ?
                                                ClausesData.data.response.map((item, index) => {
                                                    var tempData = item.clauseDetails
                                                    console.log("tempdata", tempData)
                                                    console.log("tempdata", tempData.naceCode)
                                                    return (
                                                        <tr key={index}>
                                                            <td className="text-center">{index + 1}</td>
                                                            {/* <td className="text-center">{item.firstName}</td> */}
                                                            <td className="text-center">{item.nameOfProcess}</td>


                                                            <td colspan="4">
                                                                {

                                                                    tempData ?
                                                                        tempData.map((subitem, subindex) => {
                                                                            return (
                                                                                <table className="table table-bordered">
                                                                                    <tbody key={subindex}>
                                                                                        <tr>
                                                                                            <td style={{ "width": "120px" }}>{subitem.clauseNo}</td>
                                                                                            <td style={{ "width": "120px" }}>{subitem.clauseDescription}</td>

                                                                                        </tr>

                                                                                    </tbody>
                                                                                </table>

                                                                            )
                                                                        })
                                                                        :
                                                                        <>No  Clauses data addded</>
                                                                }

                                                            </td>
                                                            <td className="text-center">
                                                            {/* <input type='checkbox' name="checkbox1" value="false" id="checkboxbutton1" onChange={() => onSelection(item.orgCode, "sur2")}/>&nbsp; */}
                                                            <input type="checkbox" name="checkbox1" value="false" onChange={() => onSelection()} checked/>
                                                            </td>



                                                        </tr>
                                                    )
                                                })
                                                :
                                                <>No Data Added </>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </Form>

                }
            </Formik>
        </div>
    )
}
export default ListofImsClauses